
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/spellify",
      function () {
        return require("private-next-pages/spellify/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/spellify"])
      });
    }
  